import React, { useState } from "react";
import "./style.css";
import axios from "axios";
import Accordion from "react-bootstrap/Accordion";
import { FaDownload } from "react-icons/fa";
import { FaSpinner } from "react-icons/fa6";
import DatePicker from "react-datepicker";
import Swal from "sweetalert2";

const ReportTransit = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showTable, setShowTable] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const invalidDate = endDate < startDate;

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // ✅ FUNCION 1: obtener datos
  const getData = async () => {
    if (invalidDate) {
      Swal.fire({
        title: "La fecha de fin no puede ser anterior a la fecha de inicio",
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    setLoading(true);
    try {
      const body = {
        date_start: formatDate(startDate),
        date_end: formatDate(endDate),
      };

      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/report_transit/get_transits`,
        body,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        console.log(res.data.data);
        setData(res.data.data);
        setShowTable(true);
      }
    } catch (error) {
      console.error("Error al obtener datos", error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FUNCION 2: descargar Excel
  const downloadXLS = async () => {
    if (invalidDate) {
      Swal.fire({
        title: "La fecha de fin no puede ser anterior a la fecha de inicio",
        icon: "warning",
        iconColor: "#FCC732",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
      return;
    }

    setLoading(true);
    try {
      const body = {
        date_start: formatDate(startDate),
        date_end: formatDate(endDate),
      };

      const response = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/report_transit/xls_transits`,
        body,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (response.data.message === "No se encontraron datos") {
        Swal.fire({
          title: "Descarga Fallida",
          text: "No se encontraron datos",
          icon: "warning",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }

      if (response.data.code === 1) {
        const url = response.data.url;
        window.open(url, "_blank");

        Swal.fire({
          title: "Descarga completada",
          text: "El archivo XLS se ha descargado correctamente.",
          icon: "success",
          customClass: {
            confirmButton: "btn-ok",
            title: "alert-title",
            popup: "alert-bg",
          },
        });
      }
    } catch (error) {
      console.error("Error al descargar Excel:", error);
      Swal.fire({
        title: "Error al descargar el archivo",
        icon: "error",
        iconColor: "#E74C3C",
        customClass: {
          confirmButton: "btn-ok",
          title: "alert-title",
          popup: "alert-bg",
        },
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Accordion defaultActiveKey="0" className="accordion-center">
        <Accordion.Item eventKey="0">
          <Accordion.Header>Filtros</Accordion.Header>
          <Accordion.Body>
            <div className="form-inline text-center filter-container">
              <div className="d-inline-block mt-2 mr-2 text-center">
                <label>Fecha Inicio</label>
                <br />
                <DatePicker
                  selected={startDate}
                  onChange={(date) => {
                    setStartDate(date);
                  }}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                />
              </div>
              <div className="d-inline-block mt-2 mr-2 text-center">
                <label>Fecha Fin</label>
                <br />
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="form-control"
                  minDate={startDate}
                />
              </div>
              <div className="d-inline-block mt-2 mr-1 text-center btn-filter">
                <button
                  className="btnn"
                  id="downlaod-xls"
                  onClick={downloadXLS}
                  disabled={loading}
                >
                  XLS
                  <FaDownload />
                </button>
              </div>
              <div
                className="d-inline-block mt-2 mr-1 text-center btn-filter"
                id="search-container"
              >
                <button
                  className="btnn"
                  style={loading ? {display: "none"} : {  }}
                  id="search"
                  onClick={getData}
                  disabled={invalidDate || loading}
                >
                  Aplicar
                </button>
                <FaSpinner
                  className="loader-spiner-filter"
                  style={loading ? {} : { display: "none" }}
                />
              </div>
            </div>
            {invalidDate && (
              <p style={{ color: "red", marginTop: "10px" }}>
                ⚠️ La fecha fin no puede ser menor que la fecha inicio.
              </p>
            )}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      {showTable && (
        <table
          className="table mt-5"
          style={{ width: "100%", margin: "0px, auto" }}
        >
          <thead className="text-center">
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              Master
            </th>
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              Piezas
            </th>
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              Peso
            </th>
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              Origen
            </th>
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              Destino
            </th>
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              T.Tranfer
            </th>
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              Fecha entrada
            </th>
            <th style={{ backgroundColor: "rgb(2, 12, 65)", color: "white" }}>
              Fecha de salida
            </th>
          </thead>
          <tbody className="text-center">
            {data.map((item, index) => (
              <tr key={index}>
                <td>{item.master}</td>
                <td>{item.pieces}</td>
                <td>{item.weight}</td>
                <td>{item.origin}</td>
                <td>{item.destination}</td>
                <td>{item.ttransfer}</td>
                <td>{item.entry_date}</td>
                <td>{item.exit_date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
};

export default ReportTransit;
